module.exports = __webpack_public_path__ + "img/student.ddfbe917.png";